export enum PaymentRequestType {
    OrderCancelationFee = 0,
    TravelVoucher = 1,
}
